"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var prop_types_1 = tslib_1.__importDefault(require("prop-types"));

var react_1 = tslib_1.__importDefault(require("react"));

function WidgetDangerousSource(_a) {
  var source = _a.data.source;
  return react_1["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: source || ''
    }
  });
}

WidgetDangerousSource.propTypes = {
  data: prop_types_1["default"].shape({
    source: prop_types_1["default"].string
  })
};
WidgetDangerousSource.defaultProps = {
  data: {}
};
exports["default"] = WidgetDangerousSource;